module.exports = __webpack_public_path__ + "static/media/autMenores.a8516727.pdf";